import { Component } from '@angular/core';

import { MENU_ITEMS } from './views-menu';
import { User } from '../model/user/user';
import { AuthService } from '../auth/auth-service.service';
import { UserService } from '../services/user/user.service';
import { Role } from '../enums/role.enum';
import { MENU_SETTINGS } from './views-menu-settings';
import { MENU_REQUEST } from './views-menu-request';
import { MENU_ATTENDANCE } from './views-menu-attendance';
import { MENU_REPORT } from './views-menu-report';

@Component({
  selector: 'ngx-views',
  styleUrls: ['views.component.scss'],
  template: `
    <ngx-one-column-layout>
      <nb-menu [items]="menu"></nb-menu>
      <router-outlet></router-outlet>
    </ngx-one-column-layout>
  `,
})
export class ViewsComponent {
  menu: any[] = [];
  public userDetails: firebase.User = null;
  public user: User;
  constructor(private userService: UserService) {
    this.userDetails = JSON.parse(localStorage.getItem('userAuth'));
    this.userService.getUserByUid(this.userDetails.uid).then((result) => {
      result.forEach((userRecord) => {
        this.user = { id: userRecord.id, ...userRecord.data() } as User;
        if (this.user.roles.findIndex(r => r == Role.ADMIN.toString()) > -1) {
          this.menu.push(MENU_SETTINGS);
          this.menu.push(MENU_REPORT);
        } 
        if (this.user.roles.findIndex(r => r == Role.CONSULTOR.toString()) > -1){
          this.menu.push(MENU_ATTENDANCE);
        } 
        if (this.user.roles.findIndex(r => r == Role.CIUDADANO.toString()) > -1){
          this.menu.push(MENU_REQUEST);
        }
      });
      return true;
    }).catch(() => {
    });

  }
}
